module.exports = __webpack_public_path__ + "img/astral_23.7d126add.svg";